import React from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

export const StreetForm = ({ form, onFinish }) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        name="name"
        label="Nom de la Rue"
        rules={[
          { required: true, message: "Veuillez entrer le nom de la Rue" },
        ]}
      >
        <Input placeholder="Entrez le nom de la rue" />
      </Form.Item>
      <Form.Item
        name="name_ar"
        label="اسم الشارع"
        rules={[
          {
            required: true,
            message: "الرجاء إدخال اسم الشارع",
          },
        ]}
        className="text-right"
        labelCol={{ style: { textAlign: "right" } }}
      >
        <Input placeholder="أدخل اسم الشارع" className="text-right" dir="rtl" />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <TextArea rows={4} placeholder="Entrez la description de la rue" />
      </Form.Item>
    </Form>
  );
};
